import { QueryOrder, TQueryOrderArray, TQueryOrderObject } from "@cubejs-client/core";

export const convertQueryOrderToArray = (order: TQueryOrderObject | TQueryOrderArray | undefined) => {
  if (Array.isArray(order)) return order;
  return Object.entries(order ?? []).map(([key, order]) => {
    return [key, order] as [string, QueryOrder];
  });
};
